import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ToastService } from '../../services/toast.service';
import { DriverService } from '@core/services/driver.service';
import { TypeOfPendingPayment } from '@shared/constant/shared.constant';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-cancel-modal',
  templateUrl: './cancel-modal.component.html',
  styleUrls: ['./cancel-modal.component.scss']
})
export class CancelModalComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  bodyText = '';
  headerText = '';
  fullUrl: string;
  id: string;
  comingFromInvoice: boolean;
  bookingId: any;
  invoiceId: any;

  constructor(
    public readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig,
    private readonly toastService: ToastService,
    private readonly driverService: DriverService) { }

  ngOnInit(): void {
    this.bodyText = this.config?.data?.bodyText;
    this.headerText = this.config?.data?.headerText;
    this.id = this.config?.data?.id;
    this.bookingId = this.config?.data?.bookingId || null;
    this.invoiceId = this.config?.data?.invoiceId || null;
    this.comingFromInvoice = this.config?.data?.comingFromInvoice
  }

  cancelBookingFunc() {
    
    const payload = {
      bookingId: this.id
    };
    
    this.driverService.CancelAssistedPendingBookingById(payload)
    .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          this.ref.close(response);
          if (response) {
            this.toastService.showToastMessage(
              'success',
              'Success',
              response.message
            );
          }
          
        }, error: (error) => {
          this.ref.close();
          this.toastService.showToastMessage('error', 'Error', error.error.message);
        }
      })
  }

  cancelBookingInvoiceFunc() {
    
    let apiCall$;
    let payload;
    if (this.config?.data?.type === TypeOfPendingPayment.Booking || this.config?.data?.type === TypeOfPendingPayment.DeferredInvoice) {
      // Payload for CancelAssistedPendingBookingById
      payload = {
        bookingId: this.bookingId,
      };
      apiCall$ = this.driverService.CancelAssistedPendingBookingById(payload);
    } else {
      // Payload for CancelMyInvoiceByIdOrBookingId
      payload = {
        bookingId: this.bookingId,
        invoiceId: this.invoiceId,
      };
      apiCall$ = this.driverService.CancelMyInvoiceByIdOrBookingId(payload);
    }

    apiCall$
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.ref.close(response);
        if (response) {
          this.toastService.showToastMessage(
            'success',
            'Success',
            response.message
          );
        }
        
      },
      error: (error) => {
        this.ref.close();
        
        this.toastService.showToastMessage('error', 'Error', error.error.message);
      },
    });
  }  

  cancel(): void {
    this.ref.close();
    
  }

}
